<!--
frontend-author:Pramoth,
backend-author: bhavya,
page-name :TaxSummary.vue,
page-description :Tax Summary,
started at : 15-April-2020.,
edited at :15-April-2020.
-->
<!-- Html code for aging details-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,1)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span slot="text">
              <i class="la la-cog la-lg mr-1"></i>
              Customize Report
            </span>
          </template>
          <!-- For filter -->
          <b-dropdown-item v-b-modal.TaxSummary>General</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="no_caret_import la la-download mx-2"></span>Export Tax Summary
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{org_name}}</p>
            <h4 class="fw-semi-bold">Tax Summary</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead class="tbl-col">
                <tr>
                  <th style="width:120px !important">
                    <router-link
                      :to="{ name : 'TaxSummary',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,report_by:$route.query.report_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'tax_name'} }"
                      class="text-dark text-decoration-none"
                    >
                      Tax Name
                      <small class="text-muted" v-if="label == 'tax_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:150px !important" class="text-right">
                    <router-link
                      :to="{ name : 'TaxSummary',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,report_by:$route.query.report_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'tax_percent'} }"
                      class="text-dark text-decoration-none"
                    >
                      Tax Percent(%)
                      <small class="text-muted" v-if="label == 'tax_percent'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:150px !important" class="text-right">
                    <router-link
                      :to="{ name : 'TaxSummary',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,report_by:$route.query.report_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'subtotal_without_tax'} }"
                      class="text-dark text-decoration-none"
                    >
                      Total without tax
                      <small
                        class="text-muted"
                        v-if="label == 'subtotal_without_tax'"
                      >
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:160px !important" class="text-right">
                    <router-link
                      :to="{ name : 'TaxSummary',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,report_by:$route.query.report_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'tax_amount'} }"
                      class="text-dark text-decoration-none"
                    >
                      Tax Amount
                      <small class="text-muted" v-if="label == 'tax_amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->
              <tbody>
                <tr v-if="lists.length==0">
                  <td colspan="4" class="text-center">No data to display.</td>
                </tr>
                <template v-else>
                  <tr
                    v-for="(list,index) in lists"
                    :key="index"
                    @click="oldRoute = {query:$route.query,total_amount:list.subtotal_without_tax,tax_amount:list.tax_amount}"
                  >
                    <td>
                      <router-link
                        :to="{ name : 'TaxDetails',params:{id:list.tax_id,title:list.tax_name},query: {report_by:$route.query.report_by,page:1,show:10,from_date:$route.query.from_date,to_date:$route.query.to_date, id:list.tax_id,title:list.tax_name} }"
                      >{{list.tax_name}}</router-link>
                    </td>
                    <td class="text-right">{{ list.tax_percent }}</td>
                    <td
                      class="text-right"
                    >{{orgCurrencySymbol+' '+Number(list.subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                    >{{orgCurrencySymbol+' '+Number(list.tax_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      id="TaxSummary"
      title="Customize Report"
      body-class="bg-white"
      size="md"
      ref="runreport"
      ok-title="Run Report"
      @ok="onRunReport()"
      cancel-variant="light"
    >
      <b-row>
        <b-col cols="8">
          <b-form-group label="Date Range" label-for="date-range">
            <GlobalDateRangePicker
              class="pr-4"
              ref="daterangeupdate"
              :singleDatePicker="false"
              v-on:setDateRange="getDateRange($event,1)"
              :fromDate="from_date"
              :toDate="to_date"
            />
          </b-form-group>
          <b-form-group label="Group By" label-for="group_by">
            <v-select
              :clearable="false"
              v-model="report_by"
              index="value"
              label="label"
              :options="[{value:1,label:'All'},{value:2,label:'Sales'}]"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Tax Summary'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import vSelect from "vue-select"; // searchable select dropdwon
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import moment from "moment";
import { formatDate } from "@/mixins/formatDate";

function getTaxSummaryDetails(routeTo, next) {
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchTaxSummary", {
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: { vSelect },
  mixins: [formatDate],
  props: {
    label: [String, Number],
    sort: [String, Number]
  },
  name: "TaxSummary",
  data() {
    return {
      export_data: [],
      export_modal: false,
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      report_by: parseInt(this.$route.query.report_by || 1),
      org_name: this.$AppDetails.organization.comp_name || "",
      export_xl: {
        "Tax Name": "tax_name",
        "Tax Percent": "tax_percent",
        "Total without tax": "subtotal_without_tax",
        "Tax Amount": "tax_amount"
      }
    };
  },
  created() {
    this.$router.push({
      name: this.$route.name,
      query: {
        from_date: this.from_date,
        to_date: this.to_date,
        report_by: this.report_by
      }
    });
  },
  methods: {
    fetchExportData() {
      return this.lists;
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },

    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    },
    onRunReport() {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          label: this.label,
          sort: this.sort,
          report_by: this.report_by
        }
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getTaxSummaryDetails(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getTaxSummaryDetails(routeTo, next);
  },
  computed: {
    ...mapState({ lists: state => state.reports.lists }),
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    },
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"])
  }
};
</script>

<!--  Sales by Customer style -->
